import React, { useEffect, useState } from "react";
import Head4Top from "./Head4Top";
import Footer4Bottom from "./Foot4Bottom1";
import Css from './Layout.module.css'
import { Col, Row } from "react-bootstrap";
import { json, Link, useNavigate } from "react-router-dom";
import Footer4Bottom1 from "./Foot4Bottom1";
import UtilClass from "api_ref/UtilClass";
/*const arr_menu = [

    { seq: 1, name: 'หน้าแรก', icon: 'fa-solid fa-house', link: '/home', desc: 'admin', type: 'main' },
    { seq: 2, name: 'รายการลูกค้า', icon: 'fa-solid fa-building-user', link: '/company', desc: 'admin', type: 'main' },
    //{seq:6,name:'ตั้งค่า',icon:'fa-solid fa-layer-group',link:'/admin/config',desc:'admin'},
    { seq: 3, name: 'บัญชี', icon: 'fa-solid fa-calculator', link: '#', desc: 'admin', type: 'headsub' },
    { seq: 4, name: 'รายการทั้งหมด', link: '/account/quontation-list', desc: 'admin', type: 'sub' },
    //{seq:4,name:'รอจัดทำใบแจ้งหนี้',link:'/account/waiting-invoice',desc:'admin',type:'sub'},
    //{seq:5,name:'รอตรวจสอบการชำระเงิน',link:'/account/waiting-check-payment',desc:'admin',type:'sub'},
    //{seq:6,name:'เอกสารหัก ณ ที่จ่าย',link:'/account/wait-checking-withholding-tax',desc:'admin',type:'sub'},
    //{seq:7,name:'เสร็จสมบูรณ์',link:'/account/complete-documents',desc:'admin',type:'sub'},
    { seq: 8, name: 'เซลล์/ มาร์เก็ตติ้ง', icon: 'fa-solid fa-comments-dollar', link: '#', desc: 'admin', type: 'headsub' },
    //{seq:9,name:'รายการชำระ/ตรวจสอบแล้ว',link:'/paytransaction',desc:'admin',type:'sub'},
    { seq: 10, name: 'รายการทั้งหมด', link: '/paytransaction', desc: 'admin', type: 'sub' },
    { seq: 11, name: 'ข้อมูลของคุณ', icon: 'fa-solid fa-user', link: '#', desc: 'admin', type: 'main' },  
    { seq: 12, name: 'บัญชีของคุณ', link: '/my/profile', desc: 'admin', type: 'sub' },

   
    { seq: 14, name: 'รายการส่งเมล', icon: 'fa-solid fa-envelope', link: '/listemail', desc: 'admin', type: 'main' },
    { seq: 15, name: 'ตั้งค่าระบบ (danger-zone)', icon: 'fa-solid fa-gear', link: '#', desc: 'admin', type: 'main' },
    { seq: 16, name: 'ตั้งค่าแอพพลิเคชั่น', link: '/setting/config-app', desc: 'admin', type: 'sub' },
    { seq: 17, name: 'ตั้งค่าอีเมล', link: '/setting/config-email', desc: 'admin', type: 'sub' },
    { seq: 18, name: 'ตั้งค่าเนื้อความอีเมล', link: '/setting/config-template-email', desc: 'admin', type: 'sub' },
    { seq: 19, name: 'ตั้งค่าแพ็กเกจ', link: '/setting/package', desc: 'admin', type: 'sub' },
    { seq: 20, name: 'จัดการผู้ใช้ (danger-zone)', icon: 'fa-solid fa-users-gear', link: '/UserManager', desc: 'admin', type: 'main' },
    { seq: 21, name: 'จัดการสิทธิ์ผู้ใช้', icon: "fa-solid fa-user-lock", link: '/UserManagerAuthorize', desc: 'admin', type: 'main' },
    
]*/

export default function Layout4Admin1({ children, middle = undefined, role = 'admin' }) {
    const nav = useNavigate();
    const utilcls = new UtilClass();

    const [arrMenu,setArrMenu] = useState([]);
    const danger_zone = [];//[15,16,17,18,19,20];

    const customer = utilcls.getSessionStorage('_dcaas_8089');

    const getDangerZone =(id)=>{
        //console.log(id)
        if( danger_zone.findIndex( x => x === id) > -1)
            return ' text-danger';
    }
    const getMiddleClass = () => {
        if (middle === undefined) return '';
        return Css.Content_center;
    }
    const getnext = (link) => {
        nav(link);
    }

    const handleLogout = (event) => {
        nav('/');
    }

    const handleGetClass = (path) => {
        let nowPath = window.location.pathname;
        if (nowPath.indexOf(path) > -1) return Css.Selected;
        else return "";
    }

    const handleResetPage = (group)=>{
        utilcls.setCombinedSessionStorage(group,'page',1);
    }

    const handleChangeProfile = (event) => {
        nav('/my/profile');
    }

    const handleChangePass = () => {
        nav('/my/change-password');
    }

    useEffect(() => {
        //console.log(customer.arr_menu_authorize.length);
        if (customer === null) nav('/');

        if(customer.arr_menu_authorize.length > 0){
            let arr_menu = [];
            for(let i = 0;i<customer.arr_menu_authorize.length;i++){
                //console.log(customer.arr_menu_authorize[i]);

                arr_menu.push({
                    id: parseInt(customer.arr_menu_authorize[i].menu_id) , 
                    seq : parseInt(customer.arr_menu_authorize[i].menu_id) , 
                    name : customer.arr_menu_authorize[i].menu_name, 
                    icon: customer.arr_menu_authorize[i].css_class, 
                    link: customer.arr_menu_authorize[i].menu_url, 
                    desc: 'admin', 
                    type: customer.arr_menu_authorize[i].parent_menu_id === null ? 'main' : 'sub',
                    parent_id:customer.arr_menu_authorize[i].parent_menu_id
                });

            }
            setArrMenu(arr_menu);
           
        }   
    }, [])

    return (
        <>
            <div className={`${Css.bg} ${Css.Main_Content_Customer}`}>
                <div className={Css.Menu_Left + ' shadow'}>
                    <div className={Css.Header}>
                        <img src={require('images/DCasS.png')} className="me-2" />
                        <span className="fs-6">Admin Portal</span>
                    </div>
                    <div className={Css.Menu}>
                        <ul>{
                                arrMenu.filter( x => x.type === 'main')?.map((obj,index) => (
                                    <>
                                    <li key={index} className={`${handleGetClass(obj.link)} ${Css.menu_item}`}>
                                        <Link className={getDangerZone(obj.seq)} onClick={event => handleResetPage(obj.link)} to={(obj.link) }><i className={obj.icon}></i>{obj.name}</Link>
                                    </li>
                                    {
                                        arrMenu.filter(x => x.type === 'sub' && x.parent_id === obj.id)?.map((obj,index)=>(
                                            <div className={Css.marginSub} key={index}>
                                                <li key={index} className={`${handleGetClass(obj.link)} ${Css.menu_item_sub}`}>
                                                    <Link  onClick={event => handleResetPage(obj.link)} to={(obj.link)} className={` ${getDangerZone(obj.seq)}`}><i className={obj.icon}></i>{obj.name}</Link>
                                                </li>
                                            </div>
                                        ))
                                    }
                                    </>
                                ))
 
                            }
                        </ul>
                    </div>
                </div>
                <div className={Css.Content}>
                    <div className={Css.Header}>
                        <Row>
                            <Col className={'text-start'}>
                                <label className="mt-2">ยินดีต้อนรับ </label>
                            </Col>
                            <Col className={'text-end'}>
                                <div className="btn-group ">
                                    <a className="profile-dropdown dropdown-toggle" data-bs-toggle="dropdown">
                                        <img window={'auto'} height={30} alt='' src={require('images/profile.png')} />
                                        <span className="me-2 ms-2">{customer?.show_name}</span>
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-end dropdown-menu-md-start">
                                        <li>
                                            <div className="text-center p-3">
                                                <img className="d-block m-auto mb-2" width={'auto'} height={50} alt='' src={require('images/profile.png')} />
                                                <span className="d-block fs-7">{customer?.show_name}</span>
                                                <span className="d-block text-secondary">{customer?.email}</span>

                                            </div>
                                            <a className="dropdown-item" onClick={event => handleChangeProfile()}><i className="fa-regular fa-address-card me-2 "></i>Edit Profile</a>
                                        </li>
                                        <li><a className="dropdown-item" onClick={event => handleChangePass()} ><i className="fa-solid fa-key me-2"></i>Change Password</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><a className="dropdown-item" onClick={handleLogout}><i className="fa-solid fa-arrow-right-from-bracket me-2"></i>Logout</a></li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>

                    </div>
                    {children}
                </div>

            </div>
            <Footer4Bottom1 />
        </>
    );
}